<template>
  <div class="fields-client--container no-select">
    <div class="fields-client--search" v-if="search">
      <div>
        Вы искали: <b>{{ search }}</b>
      </div>
      <div>
        Перенести строку поиска:
        <div @click="moveSearch('name')" class="btn btn-sm btn-info">В имя</div>
        <div @click="moveSearch('surname')" class="btn btn-sm btn-info">
          В фамилию
        </div>
        <div @click="moveSearch('number')" class="btn btn-sm btn-info">
          В номер
        </div>
      </div>
    </div>
    <div
      v-if="client.bind_tg_bot"
      class="mrg-t-10 mrg-b-20 alert alert-sm alert-success"
    >
      Данный клиент привязан к <b>Telegram-боту</b> и может получать уведомления
    </div>
    <form @submit.prevent="addClient">
      <div class="fields-client--form">
        <div>
          <div class="input-block">
            <label :for="thisUid + 'name'"
              >Имя <span class="req">*</span></label
            >
            <input
              @focus="formError.name = ''"
              @blur="vName"
              type="text"
              v-model="client.name"
              :id="thisUid + 'name'"
            />
            <div class="form-error">{{ formError.name }}</div>
          </div>
          <div class="input-block">
            <label :for="thisUid + 'number'"
              >Номер телефона <span class="req">*</span></label
            >
            <phone-number
              v-model="client.number"
              :request-validate="requestValidateNumber"
              @mask="setPhoneMask"
            ></phone-number>
          </div>
          <div class="input-block">
            <label>
              Скидка %
              <hints :type="'text'" :title="'Скидка клиента'">
                <div slot="text">
                  Скидка будет автоматически применяться к стоимости каждой позиции.<br><br>
                  <span class="text-orange">Внимание!</span> Если, создавая запись, вы сами подкорректировали стоимость
                  какой-либо услуги, то к этим позициям скидка применяться не будет<br><br>
                  В двух словах: скидка применяется только в том случае, если на момент создания или редактирования записи стоимость
                  позиции соответствует полной стоимости
                </div>
              </hints>
            </label>
            <input
              @focus="formError.sale = ''"
              @blur="vSale"
              type="text"
              v-model="client.sale"
              :id="thisUid + 'sale'"
              inputmode="numeric"
            />
            <div class="form-error">{{ formError.sale }}</div>
          </div>
        </div>
        <div>
          <div class="input-block">
            <label :for="thisUid + 'surname'">Фамилия</label>
            <input
              type="text"
              v-model="client.surname"
              :id="thisUid + 'surname'"
            />
          </div>
          <div class="input-block">
            <label :for="thisUid + 'last-name'">Отчество</label>
            <input
              type="text"
              v-model="client.lastname"
              :id="thisUid + 'last-name'"
            />
          </div>
          <div class="input-block">
            <label :for="thisUid + 'add_client_email'">Электронная почта</label>
            <input
              @focus="formError.email = ''"
              @blur="vEmail"
              type="text"
              v-model="client.email"
              :id="thisUid + 'add_client_email'"
            />
            <div class="form-error">{{ formError.email }}</div>
          </div>
          <div class="input-block">
            <label :for="thisUid + 'date-birth'">Дата рождения</label>
            <input
              @focus="formError.birthday = ''"
              @blur="vBirth"
              v-mask="dateBirthMask"
              type="text"
              v-model="client.birthday"
              :id="thisUid + 'date-birth'"
              inputmode="numeric"
            />
            <div class="form-error">{{ formError.birthday }}</div>
          </div>
        </div>
      </div>
      <div class="input-block">
        <label :for="thisUid + 'add_client_source'">Источник привлечения</label>
        <select :disabled="!checkPermission('edit_source_client')" v-model="client.source_client_id" :id="thisUid + 'add_client_source'">
          <option value="0">Не выбран</option>
          <option v-for="item in sourceClient" :key="item.id" :value="item.id">
            {{item.name}}
          </option>
        </select>
        <div
          v-if="checkPermission('create_source_client') || checkPermission('delete_source_client')"
          @click="showAddSourcePopup"
          class="add-source"
        >
          Управление источниками
        </div>
      </div>
      <div class="input-block">
        <label :for="thisUid + 'add_client_comment'">Заметка о клиенте</label>
        <textarea
          @focus="formError.comment = ''"
          @blur="vComment"
          type="text"
          rows="6"
          v-model="client.comment"
          :id="thisUid + 'add_client_comment'"
        ></textarea>
        <div class="form-error">{{ formError.comment }}</div>
      </div>
      <div class="input-block">
        <label>
          <input
              type="checkbox"
              :id="thisUid + 'block_user'"
              v-model="client.block"
          />
          Заблокировать клиента
        </label>
        <div class="hint">
          При выборе данного параметра, нельзя будет создать запись на данный номер телефона
        </div>
      </div>
      <div class="input-block">
        <label>
          <input
              type="checkbox"
              :id="thisUid + 'is_unwanted'"
              v-model="client.is_unwanted"
          />
          Нежелательный клиент
        </label>
        <div class="hint">
          При выборе данного параметра, в записях рядом со строкой клиента
          будет отображаться надпись "Нежелательный"
        </div>
      </div>
      <div class="input-block">
        <label>
          <input
              type="checkbox"
              :id="thisUid + 'block_sms'"
              v-model="client.block_sms"
          />
          Не отправлять СМС данному клиенту
        </label>
        <div class="hint">
          При выборе данного параметра, клиенту не будут отправляться СМС-сообщения,
          не смотря на то, что они включены в настройках
        </div>
      </div>
    </form>

    <popup
      :closeButton="addSourcePopup.closeButton"
      :show="addSourcePopup.show"
      @closePopup="closeAddSourcePopup"
    >
      <div slot="header">Управление источниками привлечения</div>
      <div slot="body">
        <crud-source-client
          v-if="addSourcePopup.show"
          @updateSource="updateSourceClient"
        ></crud-source-client>
      </div>
    </popup>


  </div>
</template>

<script>

import Validator from "../../libraries/Validator";
import Hints from "@/components/Hints";
import PhoneNumber from "../../PhoneNumber";
import Popup from "../../Popup.vue";
import CrudSourceClient from "../source_client/CrudSourceClient.vue";
import permissionMixin from "@/components/mixins/Permissions";
import sourceRepository from "../../../repositories/source";

const validator = new Validator();

export default {
  name: "FieldsClient",
  components: { PhoneNumber, Hints, Popup, CrudSourceClient },
  mixins: [permissionMixin],
  data() {
    return {
      requestValidateNumber: 0,
      phoneMask: "",
      dateBirthMask: "##.##.####",
      sourceClient: [],
      client: {
        name: "",
        lastname: "",
        surname: "",
        number: "",
        email: "",
        birthday: "",
        sale: "",
        comment: "",
        source_client_id: '0',
        block: false,
        is_unwanted: false,
        block_sms: false,
        bind_tg_bot: false
      },
      formError: {
        name: "",
        number: "",
        email: "",
        birthday: "",
        sale: "",
        comment: ""
      },
      addSourcePopup: {
        show: false,
        closeButton: "Отмена"
      },
    };
  },
  props: {
    search: String, // Строка поиска для отображения
    reset: Boolean, // false - сбросить
    submit: Number, // При изменении, делает emit('submit') со всеми параметрами
    default: Object // Значение по умолчанию. Заполняет существующие поля
  },
  watch: {
    default: function(val) {
      for (let key in val) {
        this.$set(this.client, key, val[key] == null ? "" : val[key]);
      }
    },
    reset: function(val) {
      if (!val) {
        this.client = {
          name: "",
          lastname: "",
          surname: "",
          number: "",
          email: "",
          birthday: "",
          sale: "",
          comment: "",
          source_client_id: '0',
          block: false,
          bind_tg_bot: false
        };
      }
    },
    submit: function() {
      this.addClient();
    }
  },
  computed: {
    thisUid() {
      return this._uid;
    },
    validateData() {
      let errorCount = 0;
      this.vName().result == "error" ? errorCount++ : "";
      this.vNumber().result == "error" ? errorCount++ : "";
      this.vSale().result == "error" ? errorCount++ : "";
      this.vBirth().result == "error" ? errorCount++ : "";
      this.vEmail().result == "error" ? errorCount++ : "";
      this.vComment().result == "error" ? errorCount++ : "";

      return errorCount;
    }
  },
  methods: {
    updateSourceClient(val){
      this.sourceClient = val;
    },
    getSources(){
      sourceRepository.view().then(resp => {
        this.sourceClient = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    showAddSourcePopup(){
      this.addSourcePopup.show = true;
    },
    closeAddSourcePopup(){
      this.addSourcePopup.show = false;
    },
    setPhoneMask(val){
      this.phoneMask = val;
    },
    vName() {
      let validate = validator.validate([
        {
          fieldName: "Имя клиента",
          value: this.client.name,
          type: "required",
          length: 250
        }
      ]);
      validate.result == "error"
          ? (this.formError.name = validate.message)
          : (this.formError.name = "");
      return validate;
    },
    vNumber() {
      this.requestValidateNumber++;
      let validate = validator.validate([
        {
          fieldName: "Номер клиента",
          value: this.client.number,
          type: "required",
          length: 20
        },
        {
          fieldName: "Номер клиента",
          value: this.client.number,
          type: "mask",
          mask: this.phoneMask
        }
      ]);
      validate.result == "error"
        ? (this.formError.number = validate.message)
        : (this.formError.number = "");
      return validate;
    },
    vSale() {
      let validate = validator.validate([
        {
          fieldName: "Скидка",
          value: this.client.sale,
          type: "integer",
          maxValue: 100
        }
      ]);
      validate.result == "error"
        ? (this.formError.sale = validate.message)
        : (this.formError.sale = "");
      return validate;
    },
    vBirth() {
      let validate = validator.validate([
        {
          fieldName: "Дата рождения",
          value: this.client.birthday,
          type: "mask",
          mask: this.dateBirthMask
        }
      ]);
      validate.result == "error"
        ? (this.formError.birthday = validate.message)
        : (this.formError.birthday = "");
      return validate;
    },
    vEmail() {
      let validate = validator.validate([
        {
          fieldName: "Электронная почта",
          value: this.client.email,
          type: "email",
          length: 45
        }
      ]);
      validate.result == "error"
        ? (this.formError.email = validate.message)
        : (this.formError.email = "");
      return validate;
    },
    vComment() {
      let validate = validator.validate([
        {
          fieldName: "Заметка о клиенте",
          value: this.client.comment,
          type: "string",
          length: 350
        }
      ]);
      validate.result == "error"
        ? (this.formError.comment = validate.message)
        : (this.formError.comment = "");
      return validate;
    },
    moveSearch(val) {
      if (val === "name") {
        this.client.name = this.search;
      }
      if (val === "surname") {
        this.client.surname = this.search;
      }
      if (val === "number") {
        this.client.number = this.search;
      }
    },
    addClient() {
      if (this.validateData) {
        return false;
      }
      this.$emit("submit", this.client);
    }
  },
  created() {

  },
  mounted(){
    this.getSources();
  }
};
</script>

<style scoped lang="less">
.fields-client--form {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  flex-direction: row;

  & > div {
    width: 48%;
  }
}
.fields-client--search {
  margin-bottom: 15px;
}
.add-source{
  margin-top: 4px;
  font-size: 12px;
  text-decoration: underline dashed #0693e3;
  cursor: pointer;
  color: #0693e3;
}
@media (max-width: 600px) {
  .fields-client--form {
    flex-wrap: wrap;

    & > div {
      width: 100%;
    }
  }
}
</style>
